import React/*, { useState, useEffect } */ from 'react'
// import AOS from 'aos'
// import axios from 'axios'
// import Card from '../components/Card';
import Tab from '../components/Tab';

const Project = () => {
  // const [repos, setRepos] = useState([]);
  // const [page, setPage] = useState(1);

  // useEffect(() => {
  //   const fetchRepos = async () => {
  //     try {
  //       const perPage = 6;
  //       const response = await axios.get(`https://api.github.com/users/Peliah/repos?sort=created&direction=desc&per_page=${perPage}&page=${page}`);
  //       const data = response.data;

  //       // Map the required repository information into an array of objects
  //       const reposData = await Promise.all(
  //         data.map(async (repo) => {
  //           const languagesResponse = await axios.get(repo.languages_url);
  //           const languagesData = languagesResponse.data;

  //           return {
  //             id: repo.id,
  //             name: repo.name,
  //             description: repo.description,
  //             url: repo.html_url,
  //             stars: repo.stargazers_count,
  //             forks: repo.forks_count,
  //             languages: Object.keys(languagesData),
  //           };
  //         })
  //       );

  //       setRepos(reposData);
  //     } catch (error) {
  //       console.error('Error fetching repositories:', error);
  //     }
  //   };

  //   fetchRepos();
  //   AOS.init();
  // }, [page]);

  // const handlePrevPage = () => {
  //   if (page > 1) {
  //     setPage(page - 1);
  //   }
  // };

  // const handleNextPage = () => {
  //   setPage(page + 1);
  // };


  return (
    <section className="flex flex-col px-6 pt-24 text-slate-200 w-full h-full lg:h-[70vh]" id="project" >
      <section className="flex justify-start items-center lg:w-5/12 w-72 pb-10">
        <h1 className="lg:text-2xl text-xl">
          <span className="text-pink-700 ">#</span>Projects
        </h1>
        {/* <figure className="pl-4">
          <img src={stroke} alt="line" className="w-36" />
        </figure> */}
      </section>
      <Tab />

    </section>
  )
}

export default Project